"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _TableRow2 = _interopRequireDefault(require("@mui/material/TableRow"));
var _Tooltip2 = _interopRequireDefault(require("@mui/material/Tooltip"));
var _Box2 = _interopRequireDefault(require("@mui/material/Box"));
var _Skeleton2 = _interopRequireDefault(require("@mui/material/Skeleton"));
var _Typography2 = _interopRequireDefault(require("@mui/material/Typography"));
var _TableCell2 = _interopRequireDefault(require("@mui/material/TableCell"));
var _Checkbox2 = _interopRequireDefault(require("@mui/material/Checkbox"));
var _styles = require("@mui/material/styles");
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _rankingFirst = _interopRequireDefault(require("../../assets/images/ranking-first.svg"));
var _rankingSecond = _interopRequireDefault(require("../../assets/images/ranking-second.svg"));
var _rankingThird = _interopRequireDefault(require("../../assets/images/ranking-third.svg"));
var _hooks = require("../../hooks");
var _models = require("../../models");
var _user = require("../user");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function Item({
  own,
  dashed,
  blurred,
  item,
  index,
  userType,
  challenge,
  subgroup,
  isCompany,
  leaderboard,
  disableRank,
  displaySubgroups,
  displayType,
  sites,
  teams,
  subsidiaries,
  regions,
  exporting,
  disableContact,
  selectedUsers,
  onRowClick,
  selectUsers
}) {
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const {
    getProgressValue
  } = (0, _hooks.useChallenge)();
  const {
    teamsColors
  } = (0, _hooks.useSubGroupColors)({
    teams
  });
  const site = item?.subGroups?.find(({
    type
  }) => type === 'companySite');
  const team = item?.subGroups?.find(({
    type
  }) => type === 'companyTeam');
  const subsidiary = item?.subGroups?.find(({
    type
  }) => type === 'companySubsidiary');
  const region = item?.subGroups?.find(({
    type
  }) => type === 'companyRegion');
  const teamColor = team && teamsColors?.[team.id] || '#333';
  return /*#__PURE__*/_react.default.createElement(_TableRow2.default, {
    hover: Boolean(onRowClick),
    onClick: item && onRowClick ? () => item.id && onRowClick(item.id) : undefined,
    sx: {
      ...(blurred ? {
        filter: 'blur(0.25rem)'
      } : {}),
      ...(onRowClick ? {
        cursor: 'pointer'
      } : {}),
      ...(dashed ? {
        borderTopStyle: 'dashed !important'
      } : {}),
      ...(own ? {
        bgcolor: '#f3f6ff'
      } : {})
    }
  }, !exporting && !disableContact && displayType === 'individual' && userType === 'admin' && /*#__PURE__*/_react.default.createElement(_TableCell2.default, {
    align: "center",
    padding: "checkbox"
  }, item?.id && /*#__PURE__*/_react.default.createElement(_Checkbox2.default, {
    checked: item && selectedUsers[item.id] || false,
    color: "primary",
    onChange: (_, checked) => item.id && selectUsers?.({
      ...selectedUsers,
      [item.id]: checked
    }),
    onClick: event => event.stopPropagation(),
    size: "small"
  })), /*#__PURE__*/_react.default.createElement(_TableCell2.default, {
    align: "center",
    padding: "checkbox",
    sx: {
      width: 42
    }
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "inline-block",
    height: 24
  }, leaderboard && item ? !disableRank && (index === 0 || item.rank !== leaderboard[index - 1]?.rank) ? item.rank === 1 ? /*#__PURE__*/_react.default.createElement("img", {
    src: _rankingFirst.default,
    style: {
      height: 24,
      width: 24
    }
  }) : item.rank === 2 ? /*#__PURE__*/_react.default.createElement("img", {
    src: _rankingSecond.default,
    style: {
      height: 24,
      width: 24
    }
  }) : item.rank === 3 ? /*#__PURE__*/_react.default.createElement("img", {
    src: _rankingThird.default,
    style: {
      height: 24,
      width: 24
    }
  }) : /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    fontWeight: 600
  }, item.rank) : /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    fontWeight: 600
  }, "-") : /*#__PURE__*/_react.default.createElement(_Skeleton2.default, {
    height: 24,
    variant: "circular",
    width: 24
  }))), /*#__PURE__*/_react.default.createElement(_TableCell2.default, null, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    display: "flex",
    gap: 2
  }, displayType === 'individual' && (item ? /*#__PURE__*/_react.default.createElement(_user.UserAvatar, {
    user: item
  }) : /*#__PURE__*/_react.default.createElement(_Skeleton2.default, {
    height: 32,
    variant: "circular",
    width: 32
  })), item ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, item.username || t('commons.news.deleted_user'), item.jerseys && item.jerseys.length > 0 && /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    display: "flex",
    gap: 1
  }, item.jerseys.map(type => /*#__PURE__*/_react.default.createElement(_Tooltip2.default, {
    key: type,
    title: /*#__PURE__*/_react.default.createElement(_Box2.default, {
      component: "span",
      display: "flex",
      flexDirection: "column"
    }, /*#__PURE__*/_react.default.createElement("span", null, t(_models.jerseysMap[type].labelKey)), /*#__PURE__*/_react.default.createElement("span", null, t(_models.jerseysMap[type].descriptionKey)))
  }, /*#__PURE__*/_react.default.createElement("img", {
    height: 24,
    src: _models.jerseysMap[type].icon
  }))))) : /*#__PURE__*/_react.default.createElement(_Skeleton2.default, {
    variant: "text",
    width: 100
  }))), displayType !== 'individual' && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_TableCell2.default, {
    sx: {
      textAlign: 'end',
      width: 150
    }
  }, item ? item.participants || 0 : /*#__PURE__*/_react.default.createElement(_Skeleton2.default, {
    variant: "text",
    width: 50
  })), /*#__PURE__*/_react.default.createElement(_TableCell2.default, {
    sx: {
      textAlign: 'end',
      width: 150
    }
  }, challenge && item ? item.participants ? getProgressValue(challenge.type, item.progressValue / item.participants) : 0 : /*#__PURE__*/_react.default.createElement(_Skeleton2.default, {
    variant: "text",
    width: 50
  }))), isCompany && displayType === 'individual' && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, displaySubgroups && (!subgroup || subgroup.subGroupType === 'companyTeam') && teams !== null && /*#__PURE__*/_react.default.createElement(_TableCell2.default, null, item ? site?.title || '/' : /*#__PURE__*/_react.default.createElement(_Skeleton2.default, {
    variant: "text",
    width: 100
  })), displaySubgroups && (!subgroup || subgroup.subGroupType === 'companySite') && sites !== null && /*#__PURE__*/_react.default.createElement(_TableCell2.default, null, item ? team ? /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    justifyContent: "flex-start"
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    bgcolor: (0, _styles.lighten)(teamColor, 0.9),
    border: `1px solid ${teamColor}`,
    borderRadius: 1,
    paddingX: "4px",
    paddingY: "2px",
    sx: {
      color: teamColor
    }
  }, team.title)) : '/' : /*#__PURE__*/_react.default.createElement(_Skeleton2.default, {
    variant: "text",
    width: 100
  })), displaySubgroups && (!subgroup || subgroup.subGroupType === 'companySubsidiary') && subsidiaries !== null && /*#__PURE__*/_react.default.createElement(_TableCell2.default, null, item ? subsidiary?.title || '/' : /*#__PURE__*/_react.default.createElement(_Skeleton2.default, {
    variant: "text",
    width: 100
  })), displaySubgroups && (!subgroup || subgroup.subGroupType === 'companyRegion') && regions !== null && /*#__PURE__*/_react.default.createElement(_TableCell2.default, null, item ? region?.title || '/' : /*#__PURE__*/_react.default.createElement(_Skeleton2.default, {
    variant: "text",
    width: 100
  }))), (!challenge || challenge.type !== 'noTarget') && /*#__PURE__*/_react.default.createElement(_TableCell2.default, {
    style: {
      textAlign: 'end',
      width: 150
    }
  }, challenge && item ? getProgressValue(challenge.type, item.progressValue) : /*#__PURE__*/_react.default.createElement(_Skeleton2.default, {
    sx: {
      display: 'inline-block'
    },
    variant: "text",
    width: 50
  })));
}
var _default = exports.default = Item;